/**
 * Header Tokens
 */

import { bg, space, border } from "../semantic";

export const header = {
  bg: bg.elevated,
  height: "80px",
  paddingX: space.insetLg,
  borderBottom: `0.5px solid ${border.subtle}`,
} as const;
